/**
 * User: Keith
 * Author: Faris
 * Date: 6/24/15
 * Time: 10:30 AM
 */

define('app/views/calendar_details',['require','./page','text!../../../views/calendar_details.html'],function(require) {

  var Page = require('./page');
  var template = require('text!../../../views/calendar_details.html');

  return Page.extend({
	 template: _.template(template),
	 
	 render: function(){
	     
	  this.makeDates();   
	        
      if(this.rerender || !this.rendered) {
        Backbone.View.prototype.render.call(this);
        this.$el.html(this.template(this.model.attributes));
        this.rendered = true;
      }
      return this.$el;
    },
    
    makeDates: function() {
        // Type 1=single day, 2=consecutive, 3=repeated
        var date;
        console.log(this.model.attributes.CALENDAR_DETAILS);
        //var itemDate = new Date(this.model.attributes.CALENDAR_DETAILS[0].START_DATE);
        var itemDate = new Date( this.model.attributes.CALENDAR_DETAILS[0].START_DATE.split(" ")[0].replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3") );
        switch(this.model.attributes.CALENDAR_DETAILS[0].DATETYPE) {
            case 1:
                // Single day
                date = ("0" + (itemDate.getMonth() + 1)).slice(-2)+".&nbsp;"+("0" + itemDate.getDate()).slice(-2)+".&nbsp;"+itemDate.getFullYear().toString().substr(2,2);
                break;
            case 2:
                // Connect beginning and end date
                var endDate = new Date(this.model.attributes.CALENDAR_DETAILS[0].END_DATE);
                
                
                date = ("0" + (itemDate.getMonth() + 1)).slice(-2)+".&nbsp;"+("0" + itemDate.getDate()).slice(-2)+".&nbsp;"+itemDate.getFullYear().toString().substr(2,2);
                date += " through ";
                date += ("0" + (endDate.getMonth() + 1)).slice(-2)+".&nbsp;"+("0" + endDate.getDate()).slice(-2)+".&nbsp;"+endDate.getFullYear().toString().substr(2,2);                      
                break;
            case 3:
                // This is a recurring event, just show the date
                date = ("0" + (itemDate.getMonth() + 1)).slice(-2)+".&nbsp;"+("0" + itemDate.getDate()).slice(-2)+".&nbsp;"+itemDate.getFullYear().toString().substr(2,2); 
                break;
            default:
                date = "";
                break;
        }
        this.model.attributes.CALENDAR_DETAILS[0].SHOW_DATE = date;
    }
  });
});
